import { Component, Input, Output, EventEmitter } from '@angular/core';
import { UploadWizardService } from '../wizard.service';

@Component({
  selector: 'upload-wizard-photo-filtering',
  styleUrls: ['../wizard.component.scss', './photoFiltering.component.scss'],
  templateUrl: './photoFiltering.component.html',
})
export class UploadWizardPhotoFilteringComponent {
  @Input() step;
  @Input() totalSteps;
  @Output() next = new EventEmitter();
  @Output() prev = new EventEmitter();

  constructor(public uploadWizardService: UploadWizardService) {
    if (this.selectedLevel() === 'all') {
      this.selectPhotos(this.uploadWizardService.filteringLevels[0].slug);
    }
  }

  selectedLevel() {
    return this.uploadWizardService.specs.image_filtering_level;
  }

  selectPhotos(type) {
    this.uploadWizardService.specs.image_filtering_level = type;
  }
}
